type BreadcrumbUrlField = {
  path: string;
};

/**
 * Determines if the given field is a BreadcrumbUrlField.
 *
 * @param field - The field to check.
 * @returns True if the field is a BreadcrumbUrlField, otherwise false.
 */
export const isBreadcrumbUrlField = (field: BreadcrumbUrlField): field is BreadcrumbUrlField => {
  return (
    typeof field === 'object' &&
    field !== null &&
    'path' in field &&
    typeof field.path === 'string' &&
    field.path.length > 0 &&
    Object.keys(field).length === 1
  );
};
